<template>
  <div id="history-plane" v-if="shown">
    <div class="history-modal">
      <p class="title-text">{{lang=='en' ? 'Video Generation History':'동영상 생성 이력'}}</p>
      <p class="mood-text">{{lang=='en' ? '* Maximum 20 histories are shown.':'* 최근 20개 이력까지 열람 가능합니다.'}}</p>
      <table id="history-table" v-if="history.length != 0" style="width: 90%; margin: auto auto 30px auto;">
        <thead>
          <tr>
            <th>{{ lang=='en' ? 'No':'순번' }}</th>
            <th>{{ lang=='en' ? 'Timestamp':'타임스탬프' }}</th>
            <th>{{ lang=='en' ? 'File Name':'파일명' }}</th>
            <th>{{ lang=='en' ? 'Selected Mood':'선택한 무드' }}</th>
            <th>{{ lang=='en' ? 'Replay Video':'동영상 다시보기' }}</th>
            <th>{{ lang=='en' ? 'Remove':'삭제' }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in history" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ lang=='en' ? item.enqueuedDateTimeEN : item.enqueuedDateTimeKO }}</td>
            <td style="width: 50%; word-break: break-all;">{{ item.fileName }}</td>
            <td>{{ lang=='en' ? item.moodEN : item.moodKO }}</td>
            <td>
              <span v-if="item.videoEverShown" @click="onPlayVideo(item.videoUrl, item.enqueuedDateTimeEN)" style="color: blue;">{{ lang=='en' ? 'Click':'클릭' }}</span>
            </td>
            <td>
              <span @click="onRemoveHistory(item.enqueuedDateTimeEN)" style="color: blue;">{{ lang=='en' ? 'Click':'클릭' }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <p v-if="history.length == 0">No history!</p>
      <b-button class="history-close-btn" variant="primary" @click="onClose" style="font-size: 28px; width: 240px; height: 60px;">{{lang=='en' ? 'Close':'닫기'}}</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryPlane',
  props: {
    shown: {
      type: Boolean,
      required: true
    },
    history: {
      type: Array,
      required: true
    },
    lang: {
      type: String,
      required: true
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onPlayVideo(videoUrl, t) {
      this.$emit('play-video', videoUrl, t);
    },
    onRemoveHistory(timestamp) {
      this.$emit('remove-history', timestamp);
    }
  }
}
</script>

<style scoped>

#history-plane {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  align-content: center;
}

.history-modal {
  width: 90%;
  height: 80%;
  margin: auto;
  background-color: #FAFAFA;
  border-radius: 5px;
  padding: 20px 0px;
  overflow-y: auto;
}

.history-close-btn {
  margin-top: 20px;
}

.history-table {
  width: 90%;
  margin: auto auto 30px auto;
}

th, td {
  padding: 5px;
  border: 1px solid #000044;
  font-size: 20px;
}
</style>